import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';

const Accordion = ({title, description, noLine, alwaysOpen, isOpen, isChanged, onToggle: onToggleCallback}) => {
  const [isExpand, setIsExpand] = useState(alwaysOpen);

  const accordionWrapperClass = classNames('accordion-wrapper-body', {
    'accordion-no-height': alwaysOpen ? false : !isExpand,
  })

  const accordionWrapperHeaderClass = classNames('accordion-wrapper-headers', {
    'accordion-wrapper-no-height': !isExpand,
    'accordion-wrapper-headers-container': isExpand
  })

  const accordionContainerClass = classNames('accordion-wrapper', {
    'accordion-container-no-height': !isExpand,
    'accordion-container': isExpand
  })

  useEffect(() => {
    setIsExpand(isOpen)
  }, [isOpen, isChanged])

  const handleToggle = () => {
    const newState = alwaysOpen ? true : !isExpand;
    setIsExpand(newState);
    // Call external callback if provided
    if (onToggleCallback) {
      onToggleCallback(newState);
    }
  };

  return (
    <>
      <div className={accordionContainerClass}>
        <div className={accordionWrapperHeaderClass} onClick={handleToggle}>
          <div className="accordion-wrapper-header prevent-select ">{title}</div>
          <div>{isExpand ? <ChevronUp /> : <ChevronDown />}</div>
        </div>
        <div className={accordionWrapperClass}>{description}</div>
      </div>
        {!noLine && <div className="accordion-hr"></div>}
    </>
  );
};

export default Accordion;
